import React, { CSSProperties } from 'react';
import './skeleton-loader.scss';
import classNames from 'classnames';

const SkeletonLoader = ({
  style = {},
  num = 1,
  direction = 'column',
}: {
  style?: CSSProperties;
  num?: number;
  direction?: 'column' | 'row';
}) => {
  return (
    <div
      data-cy="skeleton-loader"
      className={classNames('skeleton-loader', {
        'flex-row flex-wrap': direction === 'row',
        'flex-col': direction === 'column',
      })}
    >
      {Array.from({ length: num }).map((_, i) => (
        <div key={i} className="skeleton-item rounded-lg" style={style} />
      ))}
    </div>
  );
};

export default SkeletonLoader;
